"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var icon_1 = require("../icon");
var styles_1 = require("../styles");
var state_1 = require("./state");
var styles_2 = require("./styles");
exports.SearchInput = function (props) {
    var mode = props.mode, collapsed = props.collapsed, initialText = props.initialText, placeholder = props.placeholder, onSubmit = props.onSubmit, onFocusChange = props.onFocusChange, onToggleCollapsed = props.onToggleCollapsed;
    var _a = react_1.useReducer(state_1.reducer, {
        text: initialText || '',
    }), text = _a[0].text, dispatch = _a[1];
    var displayCollapsed = mode === 'mobile' && (collapsed || collapsed === undefined);
    var inputRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (!inputRef.current || mode === 'desktop') {
            return;
        }
        if (!displayCollapsed) {
            inputRef.current.focus();
        }
    }, [inputRef, mode, displayCollapsed]);
    return (React.createElement("div", { className: styles_2.styles.container },
        React.createElement("input", { ref: inputRef, type: 'text', className: styles_2.styles.input, style: { display: displayCollapsed ? 'none' : 'inherit' }, value: text, placeholder: placeholder, onChange: function (evt) { return dispatch(state_1.setText(evt.target.value)); }, onFocus: function () { return handleFocusChange(true); }, onBlur: function () { return handleFocusChange(false); }, onKeyPress: handleKeyPress }),
        React.createElement("div", { className: styles_2.styles.icon, onPointerDown: handleIconPointerDown },
            React.createElement(icon_1.Icon, { icon: 'search', color: styles_1.getColor('textlight') }))));
    function handleFocusChange(focused) {
        if (onFocusChange) {
            onFocusChange(focused);
        }
        if (!focused && mode === 'mobile' && onToggleCollapsed) {
            onToggleCollapsed(true);
        }
    }
    function handleKeyPress(evt) {
        if (evt.charCode === 13) {
            submitSearch();
        }
    }
    function handleIconPointerDown() {
        if (displayCollapsed) {
            if (onToggleCollapsed) {
                onToggleCollapsed(!displayCollapsed);
            }
            return;
        }
        submitSearch();
    }
    function submitSearch() {
        if (onSubmit && text !== '') {
            onSubmit(text);
        }
    }
};
exports.SearchInput.displayName = 'SearchInput';
